import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { useSelector } from 'react-redux'
import { setOrderBy } from '@user/store/duplicates/PestPacLocations/slice'

export const useSaveFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const usersPref = useMemo(
    () => prefs.find((p) => p.type === 'pestPacLocationDuplicates'),
    [prefs],
  )

  return useCallback(
    (orderBy: string) => {
      dispatch(
        saveFilterPreference({
          id: usersPref?.id,
          type: 'pestPacLocationDuplicates',
          name: 'pestPacLocationDuplicates filters',
          filter: JSON.stringify({ orderBy }),
        }),
      )
      dispatch(setOrderBy(orderBy))
    },
    [dispatch, usersPref?.id],
  )
}
